export default __webpack_public_path__ + "tab1_mobileeae3c5.mp4";